<template>

<core-panel>

	<template v-slot:head>

		<h1>Publishers</h1>

		<p>The publishers with the most plays. Excludes expansions.</p>

	</template>

	<template v-slot:body>

		<app-person v-for="(item, index) in publishers" :item="item" gamesCountProperty="gamesCount" type="publisher" v-bind:key="index" v-on:more="onMoreClick" />

	</template>

</core-panel>

</template>

<script>

import Panel from './../../common/Panel'

export default {

	mixins: [Panel],

	data: function() {

		return {
			detail: 'publishers',
			publishers: []
		}

	},

	methods: {

		response: function(json) {

			this.publishers = json.publishers

		},

		onMoreClick: function(id) {

			this.$pubsub.$emit('panel.open', {
				type: 'insightsPlaysPublisher',
				id: id,
				child: true
			})

		}

	}

}

</script>